import { IPackageLookupRepository } from "../domain/repositories/IPackageLookupRepository";
import { PackageLookupUseCase } from "../domain/useCases/PackageLookupUseCase";
import { PackageLookupImpl } from "../data/PackageLookupImpl";
import { PackageLookupViewModel } from "../presentation/viewModel/PackageLookupViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class PackageLookupInjection extends InjectionModule {
  private static readonly packageLookupRepositoryToken = Symbol(
    "IPackageLookupRepository",
  );
  private static readonly packageLookupUseCaseToken = Symbol(
    "PackageLookupUseCase",
  );
  private static readonly packageLookupViewModelToken = Symbol(
    "PackageLookupViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.packageLookupRepositoryToken,
      useClass: PackageLookupImpl,
    },
    {
      scope: "otherRepo",
      token: this.packageLookupUseCaseToken,
      useClass: PackageLookupUseCase,
    },
    {
      scope: "viewModel",
      token: this.packageLookupViewModelToken,
      useClass: PackageLookupViewModel,
    },
  ];

  static getRepo(): IPackageLookupRepository {
    return this.resolve(this.packageLookupRepositoryToken);
  }

  static getUseCase(): PackageLookupUseCase {
    return this.resolve(this.packageLookupUseCaseToken);
  }
}
